import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'time24'
})
export class TimeFormat24Pipe implements PipeTransform {
    transform(value: Date, args?: any): any {
        return moment(value).format("HH:mm")
    }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/pipesFiles/timeFormat24.pipe.ts